import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Button,
  UncontrolledTooltip,
  Input,
  DropdownToggle,
  DropdownMenu,
  Dropdown,
  DropdownItem,
  Row,
  Col,
  Card,
  CardBody,
  UncontrolledDropdown,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { useSelector, useDispatch } from "react-redux";
import { connectSocket, getSocket } from "../../utils/socket";
import { API_BASE_URL } from '../../config';


import {
  getDirectContact as onGetDirectContact,
  getMessages,
  getChannels as onGetChannels,
  addMessage as onAddMessage,
} from "../../slices/chat/thunk";
import avatar2 from "../../assets/images/users/avatar-2.jpg";

import FeatherIcon from "feather-icons-react";
import { fenchConversations } from "../../utils/message"

const Chat = () => {
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const [Chat_Box_Username, setChat_Box_Username] = useState("Lisa Parker");
  const [Chat_Box_Image, setChat_Box_Image] = useState(null);
  const [currentRoomId, setCurrentRoomId] = useState(1);
  const [contacts, setContacts] = useState([]);
  const [currentChat, setCurrentChat] = useState(null);
  const [messageInput, setMessageInput] = useState("");
  const [messageBox, setMessageBox] = useState(null);
  const [curMessage, setcurMessage] = useState("");
  const [search_Menu, setsearch_Menu] = useState(false);
  const [settings_Menu, setsettings_Menu] = useState(false);
  const [reply, setreply] = useState("");
  const [emojiPicker, setemojiPicker] = useState(false);
  
  // Ref for chat conversation container
  const chatContainerRef = useRef(null);
  

  const [typing, setTyping] = useState(false);

  const userobj = JSON.parse(sessionStorage.getItem("user"));
  
  const [inboxList, setinboxList] = useState(null);
  

  const { chats, messages } = useSelector((state) => state.Chat);
  const [currentUser] = useState({
    id: userobj.id,
    name: userobj.name,
    isActive:true
  });

  const dispatch = useDispatch();

  useEffect(() => {
    //  
    // const userId = JSON.parse(sessionStorage.getItem("user")).id;
    // if (userId) {
    //   connectSocket();
    // }
    connectSocket();

  }, []);

  useEffect(() => { 

    const loadConversations = async () => {
      try {
        const data = await fenchConversations(); 
        setinboxList(data.data);
      } catch (error) {
        console.error("Error loading profile:", error);
      } finally { 
      }
    };

    loadConversations();

  }, []);

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
      if (tab === "2") {
        dispatch(onGetDirectContact()).then((response) => {
          console.log(response);
          setContacts(response.payload);
        });
      }
    }
  };

  const onKeyPress = (e) => {
    const { key, value } = e;
    if (key === "Enter") {
      e.preventDefault();
      setcurMessage(value);
      onAddMessage(currentRoomId, currentUser.name);
    }
  };

  const addMessage = (roomId, sender) => {
    if (!curMessage.trim()) return;
  
    const now = new Date();
    const socketMessage = {
      id: Math.floor(Math.random() * 100),
      room: roomId,
      sender_id: sender,
      content: curMessage,
      createdAt: now,
      timestamp: now.getTime(), // 添加当前时间戳
      timestamp_iso: now.toISOString(), // 添加ISO格式时间戳用于显示
    };
  
    setcurMessage("");
  
    const socket = getSocket();
    if (socket) {
      console.log("Sending message:", socketMessage);
      socket.emit("send_message", socketMessage);
    } else {
      console.error("Socket is not initialized");
    } 
    dispatch(onAddMessage(socketMessage)); // Optimistically update UI
    
    // Scroll to bottom after sending message
    setTimeout(() => {
      scrollToBottom();
    }, 50);
    
    dispatch(getMessages(roomId));  
  };
  

  //Search Message
  const searchMessages = () => {
    var searchInput, searchFilter, searchUL, searchLI, a, i, txtValue;
    searchInput = document.getElementById("searchMessage");
    searchFilter = searchInput.value.toUpperCase();
    searchUL = document.getElementById("users-conversation");
    searchLI = searchUL.getElementsByTagName("li");
    Array.prototype.forEach.call(searchLI, function (search) {
      a = search.getElementsByTagName("p")[0] ? search.getElementsByTagName("p")[0] : '';
      txtValue = a.textContent || a.innerText ? a.textContent || a.innerText : '';
      if (txtValue.toUpperCase().indexOf(searchFilter) > -1) {
        search.style.display = "";
      } else {
        search.style.display = "none";
      }
    });
  };

  //Toggle Chat Box Menus
  const toggleSearch = () => {
    setsearch_Menu(!search_Menu);
  };
    //Info details offcanvas
    const toggleInfo = () => {
      setIsInfoDetails(!isInfoDetails);
    };
  
    const toggleSettings = () => {
      setsettings_Menu(!settings_Menu);
    };

    const openChat = (contact) => {
      setCurrentChat(contact);
      setChat_Box_Username(contact.name);
      setCurrentRoomId(contact.roomId);
    
      if (contact.image && contact.image.profile_url) {
        setChat_Box_Image(`${API_BASE_URL}/file/avatar/${contact.image.profile_url}`);
      } else {
        setChat_Box_Image(`${API_BASE_URL}/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp`);
      }
    
      const socket = getSocket();
      if (socket) {
        console.log("Joining room:", contact.roomId);
        socket.emit("join_room", { roomId: contact.roomId });
      } else {
        console.error("Socket is not initialized");
      }
    
      dispatch(getMessages(contact.roomId));
    };
    

  const sendMessage = () => {
    if (messageInput.trim() !== "") {
      dispatch(onAddMessage({ roomId: currentChat.roomId, content: messageInput }));
      const socket = getSocket();
      if (socket) {
        socket.emit("send_message", messageInput);
      }
      setMessageInput("");
    }
  };

  useEffect(() => {
    const socket = getSocket();
    if (socket) {
      socket.on("receive_message", (message) => {
        console.log("Received message:", message);
        
        // Only update state if it's for the correct room
        if (message.room_id === currentChat?.roomId) {
          dispatch(onAddMessage(message));
          // Scroll to bottom when receiving a message
          setTimeout(() => {
            scrollToBottom();
          }, 100);
        }
        dispatch(getMessages(message.room_id));  

      });
  
      socket.on("user_typing", ({ roomId, typingStatus }) => {
        if (roomId === currentChat?.roomId) {
          setTyping(typingStatus);
        }
      });
    }
  
    return () => {
      if (socket) {
        socket.off("receive_message");
        socket.off("user_typing");
      }
    };
  }, [currentChat, dispatch]);
  

  const handleTyping = () => {
    const socket = getSocket();
    if (socket) {
      socket.emit("typing", { roomId: currentChat?.roomId, typingStatus: true });
      setTimeout(() => {
        socket.emit("typing", { roomId: currentChat?.roomId, typingStatus: false });
      }, 3000);
    }
  };

    // emoji
    const [emojiArray, setemojiArray] = useState("");

    const onEmojiClick = (event, emojiObject) => {
      setemojiArray([...emojiArray, emojiObject.emoji]);
      let emoji = [...emojiArray, emojiObject.emoji].join(" ");
      setcurMessage(curMessage + event.emoji);
    };

  const convertTimestampToISO = (timestamp) => {
    try {
      if (!timestamp) {
        return new Date().toLocaleString();
      }
      
      // Handle different timestamp formats
      let date;
      if (typeof timestamp === 'string') {
        date = new Date(timestamp);
      } else if (typeof timestamp === 'number') {
        date = new Date(timestamp);
      } else {
        date = new Date(timestamp);
      }
      
      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.error("Invalid timestamp:", timestamp);
        return new Date().toLocaleString();
      }
      
      return date.toLocaleString();
    } catch (e) {
      console.error("Error converting timestamp:", timestamp, e);
      return new Date().toLocaleString();
    }
  };

  // Function to scroll to bottom of chat
  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      const chatContainer = chatContainerRef.current;
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };

  useEffect(() => {
    dispatch(onGetDirectContact());
    dispatch(onGetChannels());
  }, [dispatch]);

  // Auto-scroll when messages change
  useEffect(() => {
    if (messages && messages.length > 0) {
      // Use setTimeout to ensure DOM is updated before scrolling
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    }
  }, [messages]);

  // Auto-scroll when a new chat is opened
  useEffect(() => {
    if (currentChat) {
      // Use setTimeout to ensure messages are loaded before scrolling
      setTimeout(() => {
        scrollToBottom();
      }, 200);
    }
  }, [currentChat]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
            <div className="chat-leftsidebar border">
              <Nav tabs className="nav-tabs-custom nav-primary nav-justified mb-3">
                <NavItem>
                  <NavLink className={customActiveTab === "1" ? "active" : ""} onClick={() => toggleCustom("1")}>
                    Inbox
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={customActiveTab === "2" ? "active" : ""} onClick={() => toggleCustom("2")}>
                    Contacts
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={customActiveTab} className="text-muted">
                <TabPane tabId="1">
                  <SimpleBar className="chat-room-list pt-3">
                  {inboxList?inboxList.map((group) => (
                      <div key={group.title} className="contact-group px-3 py-2">
                        <h6 className="contact-title text-muted text-uppercase mb-2">{group.title}</h6>
                        {group.contacts.map((contact) => (
                          <div key={contact.id} className="contact-item d-flex align-items-center py-2 border-bottom" onClick={() => openChat(contact)}>
                            {contact.image && contact.image.profile_url ? (
                              <img src={`${API_BASE_URL}/file/avatar/${contact.image.profile_url}`} className="rounded-circle contact-avatar me-2" alt={contact.name} width="40" height="40" />
                            ) : (
                              <div className="contact-avatar-placeholder rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-2" style={{ width: "40px", height: "40px" }}>
                                {contact.name.charAt(0)}
                              </div>
                            )}
                            <div className="contact-details">
                              <p className="contact-name mb-0 fw-bold">{contact.name}</p>
                              <p className="contact-status text-muted small mb-0">{contact.status}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )):""}
                  </SimpleBar>
                </TabPane>
                <TabPane tabId="2">
                  <SimpleBar className="chat-room-list pt-3">
                    {contacts.map((group) => (
                      <div key={group.title} className="contact-group px-3 py-2">
                        <h6 className="contact-title text-muted text-uppercase mb-2">{group.title}</h6>
                        {group.contacts.map((contact) => (
                          <div key={contact.id} className="contact-item d-flex align-items-center py-2 border-bottom" onClick={() => openChat(contact)}>
                            {contact.image && contact.image.profile_url ? (
                              <img src={`${API_BASE_URL}/file/avatar/${contact.image.profile_url}`} className="rounded-circle contact-avatar me-2" alt={contact.name} width="40" height="40" />
                            ) : (
                              <div className="contact-avatar-placeholder rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-2" style={{ width: "40px", height: "40px" }}>
                                {contact.name.charAt(0)}
                              </div>
                            )}
                            <div className="contact-details">
                              <p className="contact-name mb-0 fw-bold">{contact.name}</p>
                              <p className="contact-status text-muted small mb-0">{contact.status}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </SimpleBar>
                </TabPane>
              </TabContent>
            </div>


            {/* original start */}
            
            {currentChat && (
            <div className="user-chat w-100 overflow-hidden border">
              <div className="chat-content d-lg-flex">
                <div className="w-100 overflow-hidden position-relative">
                  <div className="position-relative">
                    <div className="p-3 user-chat-topbar">
                      <Row className="align-items-center">
                        <Col sm={4} xs={8}>
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 d-block d-lg-none me-3">
                              <Link
                                to="#"
                                className="user-chat-remove fs-18 p-1"
                              >
                                <i className="ri-arrow-left-s-line align-bottom"></i>
                              </Link>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <div className="d-flex align-items-center">
                                <div className={currentChat.status=='online'?"flex-shrink-0 chat-user-img online user-own-img align-self-center me-3 ms-0": "flex-shrink-0 chat-user-img  user-own-img align-self-center me-3 ms-0"}>
                                 
                                    <img
                                      src={Chat_Box_Image}
                                      className="rounded-circle avatar-xs"
                                      alt=""
                                    />
                                  
                                  <span className="user-status"></span>
                                </div>
                                <div className="flex-grow-1 overflow-hidden">
                                  <h5 className="text-truncate mb-0 fs-16">
                                    <a
                                      className="text-reset username"
                                      data-bs-toggle="offcanvas"
                                      href="#userProfileCanvasExample"
                                      aria-controls="userProfileCanvasExample"
                                    >
                                      {currentChat.name}
                                    </a>
                                  </h5>
                                  <p className="text-truncate text-muted fs-14 mb-0 userStatus">
                                    <small>{currentChat.status}</small>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col sm={8} xs={4}>
                          <ul className="list-inline user-chat-nav text-end mb-0">
                            <li className="list-inline-item m-0">
                              <Dropdown
                                isOpen={search_Menu}
                                toggle={toggleSearch}
                              >
                                <DropdownToggle
                                  className="btn btn-ghost-secondary btn-icon"
                                  tag="button"
                                >
                                  <FeatherIcon
                                    icon="search"
                                    className="icon-sm"
                                  />
                                </DropdownToggle>
                                <DropdownMenu className="p-0 dropdown-menu-end dropdown-menu-lg">
                                  <div className="p-2">
                                    <div className="search-box">
                                      <Input
                                        onKeyUp={searchMessages}
                                        type="text"
                                        className="form-control bg-light border-light"
                                        placeholder="Search here..."
                                        id="searchMessage"
                                      />
                                      <i className="ri-search-2-line search-icon"></i>
                                    </div>
                                  </div>
                                </DropdownMenu>
                              </Dropdown>
                            </li>

                            <li className="list-inline-item d-none d-lg-inline-block m-0">
                              <button
                                type="button"
                                className="btn btn-ghost-secondary btn-icon"
                                onClick={toggleInfo}
                              >
                                <FeatherIcon icon="info" className="icon-sm" />
                              </button>
                            </li>

                            <li className="list-inline-item m-0">
                              <Dropdown
                                isOpen={settings_Menu}
                                toggle={toggleSettings}
                              >
                                <DropdownToggle
                                  className="btn btn-ghost-secondary btn-icon"
                                  tag="button"
                                >
                                  <FeatherIcon
                                    icon="more-vertical"
                                    className="icon-sm"
                                  />
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    href="#"
                                    className="d-block d-lg-none user-profile-show"
                                  >
                                    <i className="ri-user-2-fill align-bottom text-muted me-2"></i>{" "}
                                    View Profile
                                  </DropdownItem>
                                  <DropdownItem href="#">
                                    <i className="ri-inbox-archive-line align-bottom text-muted me-2"></i>{" "}
                                    Archive
                                  </DropdownItem>
                                  <DropdownItem href="#">
                                    <i className="ri-mic-off-line align-bottom text-muted me-2"></i>{" "}
                                    Muted
                                  </DropdownItem>
                                  <DropdownItem href="#">
                                    {" "}
                                    <i className="ri-delete-bin-5-line align-bottom text-muted me-2"></i>{" "}
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </li>
                          </ul>
                        </Col>
                      </Row>
                    </div>

                    <div className="position-relative overflow-auto" id="users-chat" ref={chatContainerRef}>
                      <div
                        className="chat-conversation p-3 p-lg-4"
                        id="chat-conversation"
                      >
                        <div id="elmLoader"></div>
                        <ul
                          className="list-unstyled chat-conversation-list"
                          id="users-conversation"
                        >
                          {messages &&
                            messages.filter(message => message && message.content && message.content.trim()).map((message, key) => (
                              <li
                                className={
                                  message.sender === Chat_Box_Username
                                    ? " chat-list left"
                                    : "chat-list right"
                                }
                                key={key}
                              >
                                <div className="conversation-list">
                                  {message.sender === Chat_Box_Username && (
                                    <div className="chat-avatar">
                                        <img
                                          src={Chat_Box_Image}
                                          alt=""
                                        />
                                    
                                    </div>
                                  )}

                                  <div className="user-chat-content">
                                    <div className="ctext-wrap">
                                      <div className="ctext-wrap-content shadow-none">
                                        <p className="mb-0 ctext-content">
                                          {message.content}
                                        </p>
                                      </div>
                                      <UncontrolledDropdown className="align-self-start message-box-drop">
                                        <DropdownToggle
                                          href="#"
                                          className="btn nav-btn"
                                          tag="i"
                                        >
                                          <i className="ri-more-2-fill"></i>
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem href="#" className="reply-message" onClick={() => setreply(message)}>                                            <i className="ri-reply-line me-2 text-muted align-bottom"></i>
                                            Reply
                                          </DropdownItem>
                                          <DropdownItem href="#">
                                            <i className="ri-share-line me-2 text-muted align-bottom"></i>
                                            Forward
                                          </DropdownItem>
                                          <DropdownItem href="#" onClick={(e) => handleCkick(e.target)}>
                                            <i className="ri-file-copy-line me-2 text-muted align-bottom"></i>
                                            Copy
                                          </DropdownItem>
                                          <DropdownItem href="#">
                                            <i className="ri-bookmark-line me-2 text-muted align-bottom"></i>
                                            Bookmark
                                          </DropdownItem>
                                          <DropdownItem href="#" onClick={() => dispatch(onDeleteMessage(message.id))}>
                                            <i className="ri-delete-bin-5-line me-2 text-muted align-bottom"></i>
                                            Delete
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </div>
                                    <div className="conversation-name">
                                      <small className="text-muted time">
                                        {convertTimestampToISO(message.timestamp_iso)}
                                      </small>{" "}
                                      <span className="text-success check-message-icon">
                                        <i className="ri-check-double-line align-bottom"></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            ))}
                        </ul>
                      </div>
                      <div
                        className="alert alert-warning alert-dismissible copyclipboard-alert px-4 fade show "
                        id="copyClipBoard"
                        role="alert"
                      >
                        Message copied
                      </div>
                      {emojiPicker && <div className="alert pickerEmoji">
                        <Picker disableSearchBar={true} onEmojiClick={onEmojiClick} />
                      </div>}
                    </div>

                    <div className="chat-input-section p-3 p-lg-4">
                      <form id="chatinput-form">
                        <Row className="g-0 align-items-center">
                          <div className="col-auto">
                            <div className="chat-input-links me-2">
                              <div className="links-list-item">
                                <button
                                  type="button"
                                  className="btn btn-link text-decoration-none emoji-btn"
                                  id="emoji-btn"
                                  onClick={() => setemojiPicker(!emojiPicker)}
                                >
                                  <i className="bx bx-smile align-middle"></i>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="col">
                            <div className="chat-input-feedback">
                              Please Enter a Message
                            </div>
                            <input
                              type="text"
                              value={curMessage}
// 替换为 onKeyDown
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  addMessage(currentRoomId, currentUser.id);
                                  setemojiPicker(false);
                                  setemojiArray("");
                                }
                              }}
                              onChange={e => setcurMessage(e.target.value)}
                              className="form-control chat-input bg-light border-light fs-13"
                              id="chat-input"
                              placeholder="Type your message..."
                              
                            />
                          </div>
                          <div className="col-auto">
                            <div className="chat-input-links ms-2">
                              <div className="links-list-item">
                                <Button
                                  type="button"
                                  color="primary"
                                  onClick={() => { addMessage(currentRoomId, currentUser.id); setemojiPicker(false); setemojiArray(""); }
                                  }
                                  className="chat-send waves-effect waves-light fs-13"
                                >
                                  <i className="ri-send-plane-2-fill align-bottom"></i>
                                </Button>
                              </div>
                            </div>
                          </div>
                          <div>{typing && <p className="text-muted small">Typing...</p>}</div>
                        </Row>
                      </form>
                    </div>

                    <div className={reply ? "replyCard show" : "replyCard"}>
                      <Card className="mb-0">
                        <CardBody className="py-3">
                          <div className="replymessage-block mb-0 d-flex align-items-start">
                            <div className="flex-grow-1">
                              <h5 className="conversation-name">{reply && reply.sender}</h5>
                              <p className="mb-0">{reply && reply.message}</p>
                            </div>
                            <div className="flex-shrink-0">
                              <button
                                type="button"
                                id="close_toggle"
                                className="btn btn-sm btn-link mt-n2 me-n3 fs-18"
                                onClick={() => setreply("")}
                              >
                                <i className="bx bx-x align-middle"></i>
                              </button>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            )}
           
            {/* original end */}


          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Chat;
